import { useMemo,} from 'react'
import { GetMultipleCommand,  useGetMultipleRawQuery } from '../../../../services/historicalData';
import {  getGradient,  mapHistoryItemsToChartItems } from '../../utils';
import { TLineChartItem } from '../types';


function useGetRawData(lines: TLineChartItem[], start: Date, end: Date, skip: boolean, minMaxLineColor?: string): any {

    const cmd: GetMultipleCommand = useMemo(() => {
        return {
            start: start.toISOString(), end: end.toISOString(), items: lines.map((l) => {
                return { objectId: l.objectId, resourceGroupId: l.resourceGroupId, propertyName: l.propertyName }
            })
        }
    }, [lines, start, end]);
    const { data, isLoading, isSuccess, error, isError } = useGetMultipleRawQuery({ cmd: cmd },{skip: skip});

    const dataAndLines = useMemo(() => {
        const combined = data?.map((entry, index) => {
            const line = lines.find((x) => x.objectId === entry.objectId && x.propertyName === entry.propertyName)
            return { line: line, data: entry };
        })
        const ds = combined?.map((ci,index) => {
            return {
                line: ci.line,
                dataSet: ci.line ? 
                getDataSet(ci.line, ci.data.data, start, end,index,minMaxLineColor): {}
            };
        })
        return ds;
    }, [data]);


    return {
        count: dataAndLines?.length || 0,
        items: dataAndLines,
        error: error,
        isLoading: isLoading,
        isSuccess: isSuccess,
        isError: isError
    }
}

export default useGetRawData

function getDataSet(line: TLineChartItem, data: any[], start: Date, end: Date, index: number, minMaxLineColor?: string) : any | any[]{
    return {

        borderWidth: 1,
        fill: line.fill ?? true,
        stepped: line.stepped ?? false,
        label: line.label,
        lineColor: line.lineColor,
        borderColor: line.lineColor,
        backgroundColor: function (context: any) {
            const chart = context.chart;
            const { ctx, chartArea } = chart;
            if (!chartArea) {
                // This case happens on initial chart load
                return;
            }
            return getGradient(ctx, chartArea, line.lineColor);
        },
        data: mapHistoryItemsToChartItems(data, start, end, line?.currentValue ?? 0),
        yAxisID: line.yScaleId ?? 'y',
        pointRadius: line.showPoints === undefined ? 0.0 : (line.showPoints ? 1.0 : 0.0),
        tension: 0.1
    }
    
}



